import { parseApiError } from '@cast/api-client';
import {
  DialogV2,
  Typography,
  useCloseDialog,
  tokens,
} from '@cast/design-system';
import { Organization } from '@cast/types';

import { useUpdateOrganizationMutation } from 'hooks/mutations/organization';
import { OrganizationFormValues } from 'types/organization';

import { OrganizationForm } from '@cast/features-organization-shared-create';

export type UpdateOrganizationDialogProps = {
  organization: Organization;
};

export const UpdateOrganizationDialogContent = ({
  organization,
}: UpdateOrganizationDialogProps) => {
  const closeDialog = useCloseDialog();
  const { mutate, isPending, error } =
    useUpdateOrganizationMutation(closeDialog);

  if (!organization) {
    return null;
  }

  const handleSubmit = (values: OrganizationFormValues) => {
    mutate({
      id: organization.id,
      name: values.name,
    });
  };

  return (
    <DialogV2
      testId="update-organization-dialog"
      title={`Edit ${
        organization.type === 'ORGANIZATION_TYPE_ENTERPRISE'
          ? 'enterprise'
          : 'organization'
      }`}
      slotProps={{ root: { size: 560 } }}
    >
      <OrganizationForm
        organizationId={organization.id}
        initialValues={{ name: organization.name }}
        onSubmit={handleSubmit}
        onCancel={() => closeDialog()}
        submitting={isPending}
        errors={error ? parseApiError(error) : undefined}
      >
        <Typography
          variant="P14R"
          color={tokens.theme.fg.structural.secondary}
          mt={4}
        >
          Make it easy for everyone to recognize the team they will join. Use an
          identifiable name for your organization.
        </Typography>
      </OrganizationForm>
    </DialogV2>
  );
};
